/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { Map, List } from 'immutable';

/* Insights and Trends */
export const enclaveCorrelations = getterFromKeyPath(['insights', 'enclaveCorrelations']);
export const communityCorrelations = getterFromKeyPath(['insights', 'communityCorrelations']);
export const enclaveIoCs = getterFromKeyPath(['insights', 'enclaveIoCs']);
export const communityTrendingIocs = getterFromKeyPath(['insights', 'communityTrendingIocs']);
export const malware = getterFromKeyPath(['insights', 'malware']);
export const cves = getterFromKeyPath(['insights', 'cves']);

/* Meta options */
export const viewOptions = getterFromKeyPath(['insights', 'meta', 'view']);
export const currentTimeFilter = getterFromKeyPath(['insights', 'meta', 'timeRange']);
export const enclaveSelection = getterFromKeyPath(['insights', 'meta', 'enclaveSelection']);
export const savedRanges = getterFromKeyPath(['insights', 'meta', 'savedRanges']);

/* Name of default/current selected default enclave */
export const defaultEnclaveName = createSelector(
  enclaveSelection,
  (selection: Map<any, any>) => {
    return selection.get('defaultEnclaveName');
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/insights/getters.js